import React from 'react';

const ClientBalancingNoteBadge = ({ score, label, tone }) => {
  let wrapperClass = 'bg-gray-100 text-blueDarker';

  if (tone === 'success') {
    wrapperClass = 'bg-blueLightest text-tealDeep';
  } else if (tone === 'danger') {
    wrapperClass = 'bg-redExtraLight text-redDeep';
  } else if (tone === 'neutral') {
    wrapperClass = 'bg-yellowExtraLight text-yellowDark';
  } else if (tone === 'none') {
    wrapperClass = 'bg-tealTransparent text-blueMediumDark';
  }

  return (
    <div className={`inline-flex items-center gap-1 px-3 py-1 rounded-full text-sm ${wrapperClass}`}>
      <span className={'font-semibold'}>{score} - </span>
      <span className="truncate">{label}</span>
    </div>
  );
};

export default ClientBalancingNoteBadge;
